import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';

const CategoryNoResult = props => {
  const { url_key } = props;
  const router = useRouter();

  const { register, handleSubmit } = useForm({
    defaultValues: {
      query: '',
    },
  });

  return (
    <div className='pb-[200px] pt-[140px]'>
      <h2 className='mb-2.5 text-center font-Shango text-lg leading-5'>Sorry, we could&apos;t find any products.</h2>
      <p className='text-center text-sm leading-5'>
        Please&nbsp;
        <Link
          className='underline'
          href={`/${url_key}`}
        >
          remove all filters
        </Link>
        &nbsp;to expand your results or try searching interested in.
      </p>
      <form
        className='mt-[30px] flex items-center justify-center'
        onSubmit={handleSubmit(values => {
          router.push(`/search.html?query=${values.query}`);
        })}
      >
        <input
          placeholder='Want to try searching interested in?'
          className='h-10 w-[220px] border-1 border-solid border-80583F pl-2.5 text-xs outline-0'
          {...register('query', {
            validate: value => {
              if (!value || !value.trim()) {
                return 'This field is required.';
              }
            },
          })}
        />
        <button
          type='submit'
          className='flex h-10 w-20 items-center justify-center bg-80583F text-white outline-0'
        >
          Search
        </button>
      </form>
    </div>
  );
};

export default CategoryNoResult;
